module.exports = __webpack_public_path__ + "img/frozen.c404d603.png";